module.exports = __webpack_public_path__ + "static/media/codeRule1.84e9fe3d.png";